import { Box } from "@chakra-ui/react";
import { Homeservices } from "./Components/Homeservices";
import { Navbar } from "./Components/Navbar";
import { Fslider } from "./Components/Fslider";
import { Categorylaunch } from "./Components/Categorylaunch";
import { Appliences } from "./Components/Appliences";
import { Massageservice } from "./Components/Massageservice";
import { Cleancontrol } from "./Components/Cleancontrol";
import { Luxury } from "./Components/Luxury";
import { Homerepair } from "./Components/Homerepair";
import { Bottomimg } from "./Components/Bottomimg";
import { Footer } from "./Components/Footer";

export const Landing = () => {
  return (
    <Box>
      <Navbar />
      <Homeservices />
      <Box bgColor={"#f2f4f6"}>
        <Fslider />
        <Categorylaunch />
        <Appliences />
        <Massageservice />
        <Cleancontrol />
        <Luxury />
        <Homerepair />
        <Bottomimg />
      </Box>
      <Footer />
    </Box>
  );
};
